<script>
import * as detectMobileMixin from "../shared/detect-mobile-mixin.vue";
import vSelect from "vue-select";
export default {
  props: ["pagedItems", "loading", "total"],
  mixins: [detectMobileMixin],
  data() {
    return {
      sortby: "- 排序 -",
      notFound: false,
      logoOK: {}
    };
  },
  watch: {
    sortby: function(sortby) {
      // console.log("sort by on change ", sortby);
      if (sortby != "- 排序 -" && sortby != null) {
        if (sortby == "性別") {
          sortby = "學生性別";
        }
        this.$emit("sortByOnChange", sortby);
      } else if (sortby == null) {
        this.$emit("sortByOnChange", null);
        this.sortby = "- 排序 -";
      }
    },
    pagedItems: function(pagedItems) {     
      this.checkNotFoundStatus();
    }
  },
  mounted() {
    this.checkNotFoundStatus();
  },
  methods: {
    checkNotFoundStatus() {
      if (this.pagedItems) {
        if (this.pagedItems.length == 0) {
          this.notFound = true;
        } else {
          this.notFound = false;
        }
      } else {
        this.notFound = true;
      }
    },
    showDetails() {
      this.$emit("showDetails", true);
    },
    chunkItems(items) {
      return _.chunk(items, 3);
    },
    setFocusItem(item) {
      this.focusedItem = item;
    },
    isFocused(item) {
      return this.focusedItem == item;
    }
  }
};
</script>
<style>
.isFocused {
  border: 2px dashed green;
}
</style>



// WEBPACK FOOTER //
// resources/js/sen-school/SenSchoolListViewMixin.vue